/* hs-eslint ignored failing-rules */

/* eslint-disable react/no-unused-prop-types */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import { List, OrderedMap, Set as ImmutableSet } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import PixelSelect from './PixelSelect';
import WebsiteAudiencePrivacyPolicy from './WebsiteAudiencePrivacyPolicy';
import Small from 'UIComponents/elements/Small';
import H2 from 'UIComponents/elements/headings/H2';
import Networks from 'ads-account-connection/lib/Networks';
import NetworkIcon from 'ads-account-connection/components/NetworkIcon';

class InstallPixelModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPixels: ImmutableSet()
    };
    this.onSelectedPixelChange = this.onSelectedPixelChange.bind(this);
    this.onInstallPixelsConfirmed = this.onInstallPixelsConfirmed.bind(this);
  }

  onSelectedPixelChange(selectedPixels) {
    this.setState({
      selectedPixels
    });
  }

  onInstallPixelsConfirmed() {
    const {
      pixelsByNetwork
    } = this.props;
    const {
      selectedPixels
    } = this.state;

    if (!this.props.loading) {
      this.props.installPixels(selectedPixels);
    }

    const newFacebookPixelCount = selectedPixels.filter(pixel => pixel.adNetwork === Networks.FACEBOOK).size;
    const newLinkedInPixelCount = selectedPixels.filter(pixel => pixel.adNetwork === Networks.LINKEDIN).size;
    const newAdWordsPixelCount = selectedPixels.filter(pixel => pixel.adNetwork === Networks.ADWORDS).size;
    this.props.trackEvent('modifyPixel', {
      action: 'Completed install pixel modal or onboarding step',
      context: 'install-modal',
      facebookPixels: newFacebookPixelCount ? pixelsByNetwork.get(Networks.FACEBOOK).filter(pixel => pixel.installed).size + newFacebookPixelCount : 0,
      linkedinPixels: newLinkedInPixelCount ? pixelsByNetwork.get(Networks.LINKEDIN).filter(pixel => pixel.installed).size + newLinkedInPixelCount : 0,
      adwordsPixels: newAdWordsPixelCount ? pixelsByNetwork.get(Networks.ADWORDS).filter(pixel => pixel.installed).size + newAdWordsPixelCount : 0
    });
  }

  render() {
    const {
      adAccounts,
      loading,
      onClose,
      pixelsByNetwork,
      trackEvent
    } = this.props;
    const {
      selectedPixels
    } = this.state;
    return /*#__PURE__*/_jsxs(UIModal, {
      width: 500,
      dialogClassName: "install-pixel-modal",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onClose
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.header"
          })
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.description"
            })
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(UIFormLabel, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.pixelLabel"
              })
            }), /*#__PURE__*/_jsx(PixelSelect, {
              adAccounts: adAccounts,
              pixelsByNetwork: pixelsByNetwork,
              selectedPixels: selectedPixels,
              onPixelChange: this.onSelectedPixelChange,
              disableInstalled: true,
              NetworkIcon: NetworkIcon,
              trackEvent: trackEvent,
              requireAudiencePermissionsToInstall: true
            }), /*#__PURE__*/_jsx("div", {
              className: "m-y-2",
              children: /*#__PURE__*/_jsx(Small, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.disclaimer"
                })
              })
            })]
          }), /*#__PURE__*/_jsx(WebsiteAudiencePrivacyPolicy, {})]
        })
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UILoadingButton, {
          loading: loading,
          use: "primary",
          onClick: this.onInstallPixelsConfirmed,
          disabled: selectedPixels.isEmpty(),
          "data-test-id": "confirm-install-pixel-button",
          children: !selectedPixels.size ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.addPixel"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.action",
            options: {
              count: selectedPixels.size
            }
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.cancelButton"
          })
        })]
      })]
    });
  }

}

InstallPixelModal.propTypes = {
  adAccounts: PropTypes.instanceOf(List).isRequired,
  dropdownFooter: PropTypes.node,
  enabledNetworks: PropTypes.instanceOf(ImmutableSet),
  installPixels: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  pixelsByNetwork: PropTypes.instanceOf(OrderedMap).isRequired,
  trackEvent: PropTypes.func.isRequired
};
export default InstallPixelModal;